/* eslint-disable no-multi-spaces */
/* eslint-disable react/no-multi-comp */
/* eslint-disable react-hooks/exhaustive-deps */
import 'react-datepicker/dist/react-datepicker.css';
import React, { useReducer, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { isFunction } from 'lodash';
import { useParams, useHistory } from 'react-router-dom';
import { Alert, Button } from 'rsuite';
import LockIcon from '@material-ui/icons/Lock';
import SettignsIcon from '@material-ui/icons/Settings';
// components
import { Table } from '../components/table/Table';
import { WidgetDate, ButtonIcon } from '../components';
import { WidgetStatus } from '../components/widget/WidgetStatus';
import DialogSellerPasswordReset from '../components/dialog/DialogSellerPasswordReset';
import DialogSellerAccountUpdate from '../components/dialog/DialogSellerAccountUpdate';
import DialogForm from '../components/dialog/DialogForm.js';
// constants
import statuses from '../constants/users/statuses';
import roles from '../constants/roles/roles';
// services
import cuotitasStores from '../services/cuotitasStore';
import Password from '../constants/logins/password';
import USERS from '../constants/logins/users';

function ColumnDate (cellContent) {
    return (<WidgetDate date={new Date(cellContent)} />);
}

function ColumStatus (cellContent) {
    return (<WidgetStatus {...statuses[cellContent]} />);
}

function columnActions (cellContent, row, rowIndex, { dialogSellerPasswordResetOpen, dialogSellerAccountUpdateOpen, userRole }) {
    const isDisabled = userRole.id !== roles['admin.cuotitas'];
    return (
        <>
            <ButtonIcon
                title='Configurar Cuenta'
                size='small'
                icon={(<SettignsIcon className='svg-icon' />)}
                onClick={() => dialogSellerAccountUpdateOpen(row.id)}
                disabled={isDisabled}
            />
            <ButtonIcon
                title='Resetear Password'
                size='small'
                icon={(<LockIcon className='svg-icon' />)}
                onClick={() => dialogSellerPasswordResetOpen(row.id)}
                disabled={isDisabled}

            />
        </>
    );
}

const regexPassword = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[[\]/#=?!@$%^&{}()|*+.:,;`'~_-]).{8,}$/;
const noSpacesRegexp = /^\S*$/; ;

export function CommerceSellers ({ user }) {
    const userRole = user?.roles[0].role;
    const history = useHistory();
    const { id } = useParams();

    const columns = [
        { dataField: 'id', text: 'ID', sort: false },
        { dataField: 'name', text: 'Nombre', sort: false, align: 'left' },
        { dataField: 'username', text: 'Usuario', sort: false, align: 'left' },
        { dataField: 'alta', text: 'Fecha de alta', sort: false, formatter: ColumnDate, hidden: window.innerWidth < 600 },
        { dataField: 'role', text: 'Rol', sort: false, align: 'left', headerAlign: 'left' },
        { dataField: 'status.description', text: 'Estado', sort: false, align: 'center', headerAlign: 'center', formatter: ColumStatus },
        { dataField: 'person.id', text: 'Acciones', sort: false, align: 'left', headerAlign: 'left', formatExtraData: { dialogSellerPasswordResetOpen: openDialogSellerPassword, dialogSellerAccountUpdateOpen: openDialogSellerAccount, userRole }, formatter: columnActions },
    ];

    const form = [
        { name: 'name', label: 'Nombre*', type: 'text' },
        { name: 'lastName', label: 'Apellido*', type: 'text' },
        { name: 'dni', label: 'DNI', type: 'text' },
        { name: 'bornDate', label: 'Fecha de nacimiento', type: 'date' },
        { name: 'user', label: 'Usuario*', type: 'text' },
        { name: 'password', label: 'Contraseña*', type: 'text' },
        { name: 'gender', label: 'Género', type: 'radio', options: [{ value: 'M', label: 'Masculino' }, { value: 'F', label: 'Femenino' }] },
        { name: 'role', label: 'Rol*', type: 'radio', options: [{ value: roles['seller.digital-origination'], label: 'Vendedor' }, { value: roles['admin.digital-origination'], label: 'Administrador' }] },
    ];

    const [loading, setLoading] = useState(false);

    const [store, setStore] = useState({});

    const [sellerList, setSellerList] = useState([]);
    const [sellerSelected, setSellerSelected] = useState();

    const [dialogSellerShow, setDialogSellerShow] = useState(false);
    const [dialogSellerPasswordShow, setDialogSellerPasswordShow] = useState(false);
    const [dialogSellerAccountShow, setDialogSellerAccountShow] = useState(false);

    const [query, setQueryParams] = useReducer((oldQuery, newQuery) => {
        if (isFunction(newQuery)) {
            return newQuery(oldQuery);
        }
        return newQuery;
    }, {
        sortOrder: 'desc',
        sortField: 'ID',
        pageNumber: 1,
        pageSize: 10
    });

    async function filter () {
        try {
            setLoading(true);

            const { sortField, sortOrder } = query;

            const remotesPageNumber = query.pageNumber;
            const remotesPageSize = query.pageSize;
            const remotesOrder = `${sortField}-${sortOrder.toUpperCase()}`;

            // Dado que la lista de los vendedores viene como un array dentro del comercio especifico (endpoint),
            // es necesario pasar las opciones de filtro por remotes, sino estos no se aplican
            const options = {
                remotes: `users.page(${remotesPageNumber}),users.pageSize(${remotesPageSize}),users.order(${remotesOrder})`
            };

            const stores = await cuotitasStores.getStoreSellersList(options, id);

            const sellers = stores[0].users.map(user => {
                const firstName = user.person?.attributes?.find(attribute => attribute.description === 'first_name')?.value;
                const lastName = user.person?.attributes?.find(attribute => attribute.description === 'last_name')?.value;

                return {
                    id: user.id,
                    name: (firstName && lastName && `${firstName} ${lastName}`) || 'S/D',
                    dni: user.person?.documents?.[0]?.description,
                    alta: user.created_at,
                    status: user.status,
                    username: user?.key,
                    role: user.roles[0].role.id === 13 ? 'Vendedor' : 'Administrador'
                };
            });

            setStore(stores[0]);
            setSellerList(sellers);
        }
        catch (error) {
            console.error(error);
            Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
        }
        finally {
            setLoading(false);
        }
    };

    async function validate (seller) {
        const errors = {};

        if (seller.name?.length > 60)               errors.name = 'El nombre ingresado es demasiado largo';
        if (!seller.name)                           errors.name = 'Este campo es obligatorio';

        if (seller.lastName?.length > 60)           errors.lastName = 'El apellido ingresado es demasiado largo';
        if (!seller.lastName)                       errors.lastName = 'Este campo es obligatorio';

        if (seller.user?.length > 60)               errors.user = 'La nombre ingresado es demasiado largo';
        if (!seller.user)                           errors.user = 'Este campo es obligatorio';
        if (!noSpacesRegexp.test(seller.user))      errors.user = 'El nombre de usuario no puede contener espacios';

        if (seller.password?.length > 20)           errors.password = 'La contraseña ingresada es demasiado larga';
        if (!seller.password)                       errors.password = 'Este campo es obligatorio';
        if (!regexPassword.test(seller.password))   errors.password = 'La contraseña debe tener mínimo 8 caracteres con una letra mayúscula y un caracter especial.';

        if (!seller.role)                           errors.role = 'Este campo es obligatorio';

        return errors;
    }

    async function create (seller) {
        try {
            // prepare data for core

            const sellerParsed = {
                key: seller.user,
                password: seller.password,
                idStore: parseInt(id),
                idRole: parseInt(seller.role),
                person: {
                    attributes: [
                        {
                            description: 'first_name',
                            value: seller.name
                        }, {
                            description: 'last_name',
                            value: seller.lastName
                        }, {
                            description: 'born_date',
                            value: seller.bornDate,
                        }, {
                            description: 'gender',
                            value: seller.gender
                        }
                    ],
                    documents: [
                        {
                            idType: 1,
                            document: seller.dni
                        }
                    ]
                },
            };

            if (!seller.dni) {
                delete sellerParsed.person.documents;
            };

            sellerParsed.person.attributes = sellerParsed.person.attributes.filter(attribute => !!attribute.value);

            await cuotitasStores.register(sellerParsed);

            Alert.success('La información se guardó correctamente', 3000);

            setDialogSellerShow(false);
            filter();
        }
        catch (error) {
            console.error(error);

            const dataError = error?.response?.data;
            const message = dataError.error;

            if (message === 'This username already exist.') {
                return Alert.error('Este nombre de usuario ya existe', 6000);
            }

            if (message.includes('Not found store')) {
                return Alert.error('No existe el id del comercio elegido', 6000);
            }

            if (dataError?.extra?.key === Password.invalid) {
                if (!dataError?.extra?.invalidations?.length) {
                    return Alert.error('La contraseña es invalida.', 5000);
                }

                if (dataError?.extra?.invalidations?.some(i => i === 'personal_data')) {
                    return Alert.error('La contraseña no debe contener datos como nombre, apellido, fecha de nacimiento o DNI', 8000);
                }

                const reason = dataError.extra.invalidations.join(',');

                return Alert.error(`La contraseña es invalida. Razón: ${reason}`, 10000);
            }

            if (dataError?.extra?.key === USERS.alreadyExist) {
                return Alert.error('El DNI ingresado ya existe para otro usuario.', 5000);
            }

            return Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 6000);
        }
        //
    }

    function openDialogSellerPassword (id) {
        setSellerSelected(id);
        setDialogSellerPasswordShow(true);
    };

    function openDialogSellerAccount (id) {
        setSellerSelected(id);
        setDialogSellerAccountShow(true);
    };

    function closeDialogSellerPassword () {
        setSellerSelected(0);
        setDialogSellerPasswordShow(false);
        filter();
    };

    function closeDialogSellerAccount () {
        setSellerSelected(0);
        setDialogSellerAccountShow(false);
        filter();
    };

    useEffect(() => {
        filter();
    }, [query]);

    return (
        <main className='page'>
            <div className="page-header flex space-between">
                <h1>Vendedores de {store.name}</h1>
                <div className='flex'>
                    <Button onClick={history.goBack} color='blue'>Volver a Comercios</Button>
                    <Button onClick={() => setDialogSellerShow(true)} color='blue'>Crear usuario vendedor</Button>
                </div>
            </div>
            <div className="page-content">
                <Table
                    data={sellerList}
                    columns={columns}
                    onChange={setQueryParams}
                    isLoading={loading}
                    pagination={{
                        sizePerPage: query.pageSize,
                        page: query.pageNumber,
                    }}
                />
            </div>
            {dialogSellerPasswordShow && <DialogSellerPasswordReset
                show={dialogSellerPasswordShow}
                onHide={closeDialogSellerPassword}
                idSeller={sellerSelected}
            />}
            {dialogSellerAccountShow && <DialogSellerAccountUpdate
                show={dialogSellerAccountShow}
                onHide={closeDialogSellerAccount}
                id={sellerSelected}
            />}
            <DialogForm
                title="Crear Usuario"
                schema={form}
                show={dialogSellerShow}
                onValidate={validate}
                onSubmit={create}
                onCancel={() => setDialogSellerShow(false)}
            />
        </main>
    );
}

export default connect(({ auth: { user } }) => ({ user }))(CommerceSellers);
